import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    font-size: 14px;

    .ReactQueryDevtools:first-of-type {
      & > button {
        margin-left: 80px !important;
      }
    }

    .ReactQueryDevtools:last-of-type {
      & > div {
        z-index: 99998 !important;
      }

      & > button {
        z-index: 99998 !important;
        margin-left: 140px !important;
      }
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
